import NavigationListItem from "@components/side-navbar/NavigationListItem";
import { Crown, Sparkle } from "@piiqtechnologies/svg-icons";
import { PeekBadge } from "@piiqtechnologies/ui-components";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import { useAuthContext } from "@stores/AuthContext";
import { hasDiscoverAccess, openDiscover } from "@utils";
import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
export const Discover = ({ expanded }) => {
    const intl = useIntl();
    const { user } = useAuthContext();
    const analytics = useAnalytics();
    const hasAccess = hasDiscoverAccess(user);
    // Customers with Discover go to their dashboard, everyone else to the marketing page.
    const handleDiscoverClick = () => {
        analytics.track("Discover Navigation Clicked", { hasDiscoverAccess: hasAccess });
        openDiscover(hasAccess);
    };
    return (React.createElement(NavigationListItem, { Icon: () => (React.createElement(PeekBadge, { color: "secondary", invisible: hasAccess, badgeContent: React.createElement(Crown, { width: "10px", height: "10px" }), sx: { "& .MuiBadge-badge": { minWidth: 15, height: 15, p: 0, zIndex: -1 } } },
            React.createElement(Sparkle, { width: "20px", height: "20px" }))), label: intl.formatMessage(messages.discover), expanded: expanded, active: false, onClick: handleDiscoverClick }));
};
export default Discover;
